/**
 * Allowlist of Lumina XML tag names that should be routed through `luminaToAdf`
 * instead of the markdown encoder. Anything else encountered in the parsed HTML
 * is treated as prose and serialised back via `outerHTML` so the markdown
 * encoder receives the unmodified original markup.
 */
export const LUMINA_TAGS: ReadonlySet<string> = new Set([
	'section',
	'md',
	'h',
	'smart-link',
	'smart-link-list',
	'people-entity',
	'people-entity-list',
	'people-card',
	'carousel',
]);
